import React from 'react';

const ListaPerfiles = (props) => {
    return (
        <div className="row">
            <div className="col-xs-12 top-separator-xs">
                <div className="row">
                    <div className="col-xs-4">
                        <h3 className="no-margin-bottom no-margin-top">Asignar a los perfiles...</h3>
                    </div>
                    <div className="col-xs-8">
                        {props.errorMessagePerfilesUsuarios &&
                            <label className="error zmdi-alert-circle no-margin-bottom">
                                {props.errorMessagePerfilesUsuarios}
                            </label>}
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="divisor-section">
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <button type="button" className="btn btn-link" onClick={() => { $("#listProfileModal").modal() }} >
                            Seleccionar...
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ListaPerfiles;